export default "__VITE_ASSET__9bd29e1d__"